import { Plugin, ref } from 'vue';
import { createClient, getSimpleRequestFactory } from '@infuse/api/common';
import { ConnectorConfig } from './model';
import { useAuthenticator } from '@infuse/auth/services';

export const ConnectorConfigPlugin: Plugin = {
  async install(app) {
    const config = ref({
      forwardBasicAuthDefaultValue: false,
      isAwsSnsAvailable: true,
      isAwsIotAvailable: true,
      defaultPageSize: 10000
    } as ConnectorConfig); // provide a default value to avoid issues when real config is not yet loaded/unavailable

    app.provide('connectorConfig', config);

    const authenticator = useAuthenticator();
    if (!(await authenticator.isAuthenticated())) {
      // exit if not authenticated to prevent basic auth redirect loops on login page
      return;
    }

    const client = createClient('/api/config');
    config.value = await getSimpleRequestFactory<ConnectorConfig>(client)();
  }
};
